import { capitalize, kebabCase } from 'lodash';

export const Capitalize = function (strLabel) {
  return strLabel && strLabel.charAt(0).toUpperCase() + strLabel.slice(1);
};

export const UnderscoresToTitleCase = function (str) {
  if (!str) {
    return '';
  }
  const prepositions = [
    'a',
    'an',
    'the',
    'and',
    'but',
    'or',
    'on',
    'to',
    'is',
    'for',
    'in',
    'with',
    'of'
  ];
  const regex = `/\b(${prepositions.join('|')}|([A-Z]\w*))\b/`;
  const htmlSplit = str.split('<').map(code => code.split('>'));
  const processedValue = htmlSplit.map(val => {
    if (val.length === 1) {
      return val[0]
        .split('_')
        .map((item, index) => {
          if (index === 0 || !item.match(regex)) {
            return item[0].toUpperCase() + item.slice(1);
          } else if (item.match(regex)) {
            return item;
          }
        }).join(' ');
    } else {
      return `<${val[0]}>${val[1]}`;
    }
  });

  return processedValue.join('');
};

export const Slugify = (str) => {
  str = str || "";
  str = kebabCase(str);
  str = str.replace(/[^a-zA-Z0-9\-\_]/g, "");
  return str.split("-").slice(0, 3).join("-");
};

export const KebabCase = (str) => {
  str = str || "";
  return kebabCase(str);
}

export const AlphabetizeArrayOfObjects = (array, key) => {
  let arrayCopy = Array.from(array);
  if (Array.isArray(arrayCopy)) {
    return arrayCopy.sort((value1, value2) => {
      if ((typeof value1[key] === 'string' || typeof value1[key] === 'number') && (typeof value2[key] === 'string' || typeof value2[key] === 'number')) {
        let textA = value1[key].toString().toUpperCase();
        let textB = value2[key].toString().toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      }
    })
  }
}

export const SplitFileName = (fileName) => {
  if (!fileName.includes('.')) {
    return { extension: null, name: fileName };
  }
  const splitName = fileName.split('.');
  const extension = `.${splitName.pop()}`;
  const name = splitName.join('.');
  return { extension, name };
}

export const ArrayToFormattedString = (array, preposition = 'and') => {
  // ignore null, undefined and empty values
  const curatedArr = array.filter(item => item);

  // join list by commas (oxford syntax) and preposition
  const listStart = curatedArr.slice(0, -1).join(', ');
  const listEnd = curatedArr.slice(-1);
  const conjunction = curatedArr.length <= 1 ? '' : curatedArr.length > 2 ? `, ${preposition} ` : ` ${preposition} `;

  return [listStart, listEnd].join(conjunction);
}

export const StartCase = string => string.replace(/\w+/g, capitalize);

export const EnsurePluralization = (str, count, suffix = 's') => {
  if(str && count === 1 && str.slice(-1) === suffix) {
    return str.slice(0, -1);
  }
  return str && `${str}${count !== 1 && str.slice(-1) !== suffix ? suffix : ''}`
}
